const DEFAULT_API_ORIGIN = "https://api.payhive.ng";

export const apiOrigin =
  process.env.REACT_APP_API_ORIGIN ||
  process.env.REACT_APP_API_URL?.replace(/\/api\/?$/, "") ||
  DEFAULT_API_ORIGIN;

export const adminApiBaseUrl = `${apiOrigin.replace(/\/$/, "")}/api/admin`;

type QueryValue = string | number | boolean | null | undefined;

export const buildQuery = (params: Record<string, QueryValue>) => {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      query.set(key, String(value));
    }
  });

  const text = query.toString();
  return text ? `?${text}` : "";
};

export const getReturnedObject = (payload: any) => payload?.returnedObject ?? payload?.ReturnedObject ?? payload;

export async function adminRequest<T = any>(
  path: string,
  options: RequestInit & { token?: string } = {}
): Promise<T> {
  const { token, headers, ...requestOptions } = options;
  const response = await fetch(`${adminApiBaseUrl}${path}`, {
    ...requestOptions,
    headers: {
      ...(requestOptions.body instanceof FormData ? {} : { "Content-Type": "application/json" }),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...headers,
    },
  });

  const contentType = response.headers.get("content-type") || "";
  const payload = contentType.includes("application/json") ? await response.json() : await response.blob();

  if (!response.ok || payload?.isSuccessful === false || payload?.IsSuccessful === false || payload?.isSuccessfull === false) {
    throw new Error(payload?.message || payload?.Message || payload?.title || "An error occurred");
  }

  return payload as T;
}

export async function adminDownload(path: string, token: string) {
  const response = await fetch(`${adminApiBaseUrl}${path}`, {
    headers: { Authorization: `Bearer ${token}` },
  });

  if (!response.ok) {
    throw new Error("Export failed");
  }

  return response.blob();
}
